import { eventCardClicked } from './cam-context-switcher-constants';
import 'custom-event-polyfill';
import '../../scripts/global-menu-generic-icon';
import './cam-context-switcher-favorite';

const tagName = 'cam-context-switcher-card';


const template = require(`../templates/${tagName}.ejs`);

export default class CamContextSwitcherCard extends HTMLElement {

  constructor(contextData) {
    super();
    this.contextData = contextData;
    this.onclick = this.handleClick;
  }

  connectedCallback() {
    this.classList.add(tagName);
    this.innerHTML = template(this.contextData);

    if (!this.contextData.disabled && this.contextData.display.selected) {
      this.firstChild.classList.add('selected');
    }
  }

  handleClick() {
    if(!this.contextData.disabled){
      let eventOptions = {
        detail: {
          context: this.contextData.context
        },
        bubbles: true,
        cancelable: true
      };
      this.dispatchEvent(new CustomEvent(eventCardClicked, eventOptions));
    }
  }
}

if (!customElements.get(tagName)) {
  customElements.define(tagName, CamContextSwitcherCard);
}



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-card.js